import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';

@Injectable()
export class EuropeanDateFormat extends NgbDateParserFormatter {

  parse(value: string): NgbDateStruct {
    if (! value) {
      return null;
    }
    const splitted = value.split('-');
    if (splitted.length !== 3) {
      return null;
    }
    const day = parseInt(splitted[0], 10);
    const month = parseInt(splitted[1], 10);
    const year = parseInt(splitted[2], 10);
    return {
      day: day,
      month: month,
      year: year
    };
  }

  format(date: NgbDateStruct): string {
    if (date !== null && date.day > 0 && date.month > 0 && date.year > 0){
      const day = date.day < 10 ? '0' + date.day : date.day ;
      const month = date.month < 10 ? '0' + date.month : date.month ;
      const year = date.year;
      return day + '-' + month + '-' + year;
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/ngbDateParserFormatter/europeanDateFormat.ts